import request from '@/utils/request';

export function getCourseIndex() {
  return request({
    url: '/Course/index_paging',
    silentRequest: true,
  });
}

export function getCourseList(params, silentRequest = false) {
  return request({
    url: '/Course/explore',
    params,
    silentRequest,
  });
}

export function getCourseDetail(id) {
  return request({
    url: '/course/detail',
    method: 'POST',
    data: { id },
    silentRequest: true,
    java: true,
  });
}

export function getChallengeCourseList(params, silentRequest = true) {
  return request({
    url: '/Challenge/courseList',
    params,
    silentRequest,
  });
}

export function getChallengeList(id) {
  return request({
    url: '/Challenge/getList',
    params: {
      id,
    },
  });
}

export function getChallengeDetail(params, silentRequest = false) {
  return request({
    url: '/Challenge/detail',
    params,
    silentRequest,
  });
}

export function getCourseLessonPLayUrl(courseId, lessonId) {
  return request({
    url: '/Course/lessonPlay',
    params: {
      courseId,
      lessonId,
    },
  });
}

export function getCourseLivingFloatBtnInfo() {
  return request({
    url: '/Course/livingFloatBtnInfo',
    silentRequest: true,
  });
}

export function getCourseNotice(id) {
  return request({
    url: '/course/notice',
    method: 'POST',
    data: { id },
    java: true,
  });
}

export function getCourseTryDetail(id) {
  return request({
    url: '/course/auditionDetail',
    method: 'POST',
    data: { id },
    java: true,
  });
}

export function getCourseIntroduction(id) {
  return request({
    url: '/course/introduction',
    method: 'POST',
    data: { id },
    java: true,
    silentRequest: true,
  });
}

export function getCourseOutline(id) {
  return request({
    url: '/course/outline',
    method: 'POST',
    data: { id },
    java: true,
  });
}

export function getCourseChallenge(id) {
  return request({
    url: '/course/challenge',
    method: 'POST',
    data: { id },
    java: true,
  });
}

export function getCourseComment(data) {
  return request({
    url: '/course/comment',
    method: 'POST',
    data,
    java: true,
  });
}

export function setCourseCommentLike(data) {
  return request({
    url: '/course/commentLike',
    method: 'POST',
    data,
    java: true,
  });
}
